import { useCallback } from "react";
import type { SyntheticEvent } from "react";

export function useShowFirstCaptionTrack() {
  return useCallback((event: SyntheticEvent<HTMLVideoElement>) => {
    const firstTrack = event.currentTarget.textTracks?.[0];
    if (firstTrack) {
      firstTrack.mode = "showing";
    }
  }, []);
}
